// extracted by mini-css-extract-plugin
module.exports = {"districtListItem":"VehicleDetail-module__districtListItem--2Ig1z"};